<template>
      <!-- Change Request Form -->
      <v-dialog
        content-class="documentDialog addShopDialog"
        class="addShopDialog"
        v-model="viewedAddShopDialog"
        transition="scale-transition"
        @update:returnValue="onPopupClose"
        persistent
        scrollable
        @keydown.esc="closePopup()">
        <v-card xs12 >
          <v-card-title class="documentDialog_title primary" dark>
          <v-layout row wrap >
            <v-flex xs11>
              <p>Add a new shop</p>
            </v-flex>
            <v-flex xs1 style="text-align: right;">
              <v-btn dark icon
              @click.native="closePopup()" style="" >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          </v-card-title>
           <v-card-text style="padding: 0px!important;">

            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1">Select an airport</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">SHOP information</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" step="3">POS information</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 4" step="4">Send</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-select
                        :items="getAllAirports"
                        item-text="label"
                        item-value="iata"
                        v-model="iata_selected"
                        single-line
                        outline
                        data-vv-name="iata_selected"
                        :error-messages="errors.collect('iata_selected')"
                        v-validate="'required'"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex md6>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="2" v-if="new_shop">

                  <v-layout row wrap>
                    <v-flex md6>
                      <h4>Title</h4>
                    </v-flex>
                    <v-flex md6>
                      <h3>Comment (URL, explanation)</h3>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex md6>
                      <v-text-field v-model="new_shop.name" :counter="60" label="" />
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_shop.name_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>Useful URL</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-text-field v-model="new_shop.url" :counter="400" label="" />
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_shop.url_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>Who</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-combobox
                        v-model="new_shop.who"
                        label=""
                        multiple
                        small-chips
                      >
                        <template :v-slot:selection="new_shop.who">
                          <v-chip close>
                            <strong>{{ new_shop.who }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_shop.who_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>What</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-combobox
                        v-model="new_shop.what"
                        label=""
                        multiple
                        small-chips
                      >
                        <template :v-slot:selection="new_shop.what">
                          <v-chip close>
                            <strong>{{ new_shop.what }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_shop.what_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>How</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-combobox
                        v-model="new_shop.how"
                        label=""
                        multiple
                        small-chips
                      >
                        <template :v-slot:selection="new_shop.how">
                          <v-chip close>
                            <strong>{{ new_shop.how }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_shop.how_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>Description</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-textarea
                        outline
                        name="input-7-4"
                        label=""
                        :counter="1000"
                        v-model="new_shop.description" required >
                      </v-textarea>
                    </v-flex>
                    <v-flex md6>
                      <v-textarea outline :counter="1000" v-model="new_shop.description_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <!-- <v-textarea
                    outline
                    name="input-7-4"
                    :counter="1000"
                    v-model="new_shop.proof_comment"
                    label="Comment "
                    data-vv-name="proofMessage"
                    :error-messages="errors.collect('proofMessage')"
                    v-validate="'required'"
                    required
                  ></v-textarea> -->
                </v-stepper-content>

                <v-stepper-content step="3" v-if="new_pos && new_pos.length > 0">
                  <h2>Define POS specific information</h2>
                  <br />
                  <v-layout row wrap>
                    <v-flex md6>
                      <h4>Localization description (terminal, gate,...)</h4>
                    </v-flex>
                    <v-flex md6>
                      <h3>Comment (URL, explanation)</h3>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex md6>
                      <v-text-field v-model="new_pos[current_pos].localization_text" required v-validate="'required'" :counter="60" label="" />
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_pos[current_pos].localization_text_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>Useful URL</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-text-field v-model="new_pos[current_pos].url" :counter="400" label="" />
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_pos[current_pos].url_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>Who</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-combobox
                        v-model="new_pos[current_pos].who"
                        label=""
                        multiple
                        small-chips
                      >
                        <template :v-slot:selection="new_pos[current_pos].who">
                          <v-chip close>
                            <strong>{{ new_pos[current_pos].who }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_pos[current_pos].who_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>What</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-combobox
                        v-model="new_pos[current_pos].what"
                        label=""
                        multiple
                        small-chips
                      >
                        <template :v-slot:selection="new_pos[current_pos].what">
                          <v-chip close>
                            <strong>{{ new_pos[current_pos].what }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_pos[current_pos].what_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>How</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-combobox
                        v-model="new_pos[current_pos].how"
                        label=""
                        multiple
                        small-chips
                      >
                        <template :v-slot:selection="new_pos[current_pos].how">
                          <v-chip close>
                            <strong>{{ new_pos[current_pos].how }}</strong>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="new_pos[current_pos].how_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <h4>Description</h4>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-textarea
                        outline
                        name="input-7-4"
                        label=""
                        :counter="1000"
                        v-model="new_pos[current_pos].description" required >
                      </v-textarea>
                    </v-flex>
                    <v-flex md6>
                      <v-textarea outline :counter="1000" v-model="new_pos[current_pos].description_comment" label="" />
                    </v-flex>
                  </v-layout>

                  <!-- <v-textarea
                    outline
                    name="input-7-4"
                    :counter="1000"
                    v-model="new_pos[current_pos].proof_comment"
                    label="Comment "
                    data-vv-name="proofMessage"
                    :error-messages="errors.collect('proofMessage')"
                    v-validate="'required'"
                    required
                  ></v-textarea> -->
                </v-stepper-content>

                <v-stepper-content step="4" v-if="new_shop">
                  <strong>Airport: </strong><span v-text="getSelectedAirport && getSelectedAirport.label"/><br />
                  <strong>Title: </strong> <span v-text="new_shop.name"/><br />
                  <br />
                  <div v-if="hasCommonInformation(new_shop)">
                    <h4>Common information:</h4>
                    <span v-if="new_shop.url" ><strong></strong> <span v-text="new_shop.url"/>
                    <br /></span>
                    <span v-if="new_shop.who && new_shop.who.length > 0" ><strong>Who:</strong> <span v-text="new_shop.who.join(', ')"/>
                    <br /></span>
                    <span v-if="new_shop.what && new_shop.what.length > 0" ><strong>What:</strong> <span v-text="new_shop.what.join(', ')"/>
                    <br /></span>
                    <span v-if="new_shop.how && new_shop.how.length > 0" ><strong>How:</strong> <span v-text="new_shop.how.join(', ')"/>
                    <br /></span>
                    <p v-show="new_shop.description">
                      <br />
                      <strong>Description:</strong> <br/>
                      <span v-text="new_shop.description" style="word-break: break-all;" />
                    </p>
                  </div>
                  <div v-if="new_pos && new_pos.length > 0">
                    <v-data-iterator
                      :items="new_pos"
                      :rows-per-page-items="localization_rowsPerPageItems"
                      :pagination.sync="localization_pagination"
                      content-tag="v-layout"
                      row
                      item-key="localization_name"
                      wrap
                    >
                      <template v-slot:item="props">
                        <v-flex xs12 sm6 md6 lg6 >
                          <v-card class="vcard_localization">
                            <v-card-title>
                              <v-layout>
                                <v-flex xs10>
                                  <h4 >{{ props.item.localization_text }}</h4>
                                </v-flex>
                                <v-flex xs2>
                                  <v-btn outline color="primary" fab  small dark slot="activator" @click.native="showPosForm(props.item)" class="button_edit">
                                    <v-icon color="primary" >edit</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-list v-show="hasData(props.item)" dense>
                              <v-list-tile v-show="props.item.url">
                                <v-list-tile-content><a :href="props.item.url" style="word-break: break-all;" >{{ props.item.url }}</a></v-list-tile-content>
                              </v-list-tile>
                              <v-list-tile v-if="props.item.who && props.item.who.length > 0">
                                <v-list-tile-content>Who:</v-list-tile-content>
                                <v-list-tile-content>{{ props.item.who.join(', ') }}</v-list-tile-content>
                              </v-list-tile>
                              <v-list-tile v-if="props.item.what && props.item.what.length > 0">
                                <v-list-tile-content>What:</v-list-tile-content>
                                <v-list-tile-content>{{ props.item.what.join(', ') }}</v-list-tile-content>
                              </v-list-tile>
                              <v-list-tile v-if="props.item.how && props.item.how.length > 0">
                                <v-list-tile-content>How:</v-list-tile-content>
                                <v-list-tile-content>{{ props.item.how.join(', ') }}</v-list-tile-content>
                              </v-list-tile>
                              <!-- <v-list-tile v-if="props.item.other && props.item.other.length > 0">
                                <v-list-tile-content>Others:</v-list-tile-content>
                                <v-list-tile-content>{{ props.item.other.join(', ') }}</v-list-tile-content>
                              </v-list-tile> -->
                            </v-list>
                            <div v-show="hasData(props.item)" style="padding:0 15px 15px 15px">
                              <span v-show="props.item.description">
                                <strong>Description:</strong>
                                <p style="word-break: break-all;">{{ props.item.description }}</p>
                              </span>
                            </div>
                          </v-card>
                        </v-flex>
                      </template>
                    </v-data-iterator>
                  </div>
                </v-stepper-content>

                <v-stepper-content step="5">
                  <div
                    class="mb-5"
                    height="200px"
                    style="text-align:center; padding-top:50px;">
                    <h3>
                      Thank you for your contribution!
                    </h3>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
          <v-card-actions class="bottom_panel">
              <!-- stepper 1 -->
              <v-btn color="primary" @click="stepper_go_to_step_2()" v-if="e1 == 1">Continue</v-btn>
              <v-btn flat @click.native="closePopup()" v-if="e1 == 1">Cancel</v-btn>

              <!-- stepper 2 -->
              <v-btn v-if="e1 == 2" color="primary" disable="checkDatas" @click="stepper_go_to_step_3()" >Continue</v-btn>
              <v-btn v-if="e1 == 2" flat @click="stepper_back_to_step_1()" >Back</v-btn>

              <!-- stepper 3 -->
              <v-btn v-if="e1 == 3" color="secondary" disable="checkDatas" @click="stepper_go_to_step_4_new_pos()" >Add new POS</v-btn>
              <v-btn v-if="e1 == 3" color="primary" disable="checkDatas" @click="stepper_go_to_step_4()" >Continue</v-btn>
              <v-btn v-if="e1 == 3" flat @click="stepper_back_to_step_2()" >Back</v-btn>

              <!-- stepper 4 -->
              <v-btn v-if="e1 == 4" color="primary" disable="checkDatas" @click="stepper_go_to_step_5()" >Send</v-btn>
              <v-btn v-if="e1 == 4" flat @click="stepper_back_to_step_3()" >Back</v-btn>

              <!-- stepper 5 -->
              <v-btn color="secondary" flat v-if="e1 == 5" @click.native="closePopup()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
import ALL_AIRPORTS from '@/graphql/AllAirports.gql'
import CREATE_CHANGE_REQUEST from '@/graphql/CreateChangeRequest.gql'
import { Component } from 'vue-instantsearch'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapMutations, mapState } = createNamespacedHelpers('locationForm')

export default {
  name: 'AddShopForm',
  mixins: [Component],
  data () {
    return {
      iata_selected: false,
      e1: 0,
      current_pos: 0,
      new_shop: false,
      new_pos: [],
      new_shopDefaultData: {
        'airport_name': '',
        'name': '',
        'localization_text': '',
        'note': '',
        'url': '',
        'who': [],
        'what': [],
        'how': [],
        'description': '',
        'name_comment': '',
        'localization_text_comment': '',
        'note_comment': '',
        'url_comment': '',
        'who_comment': '',
        'what_comment': '',
        'how_comment': '',
        'description_comment': '',
        'proof_comment': ''
      },
      localization_pagination: {
        rowsPerPage: 8,
        sortBy: 'localization_text'
      },
      localization_rowsPerPageItems: [8, 16, 32],
      error_message: null,
      dictionary: {
        custom: {
          iata_selected: {
            required: () => 'You must select an airport !'
          },
          proofMessage: {
            required: () => 'Proof / Message can not be empty'
          }
        }
      },
      allAirports: []
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  computed: {
    ...mapState(['viewedAddShopDialog']),
    getAllAirports () {
      this.allAirports.map(airport => {
        airport['label'] = airport.iata + ' ' + airport.airport_name
      })
      return this.allAirports
    },
    getSelectedAirport () {
      const airportList = this.allAirports.filter(airport => airport.iata === this.iata_selected)
      return airportList.length === 1 ? airportList[0] : false
    }
  },
  methods: {
    ...mapMutations(['setViewedAddShopDialog']),
    ...mapActions(['createNewShop']),
    stepper_back_to_step_1 () {
      this.error_message = null
      this.e1 = 1
    },
    stepper_back_to_step_2 () {
      this.error_message = null
      this.e1 = 2
    },
    stepper_back_to_step_3 () {
      this.error_message = null
      this.e1 = 3
    },
    async stepper_go_to_step_2 () {
      this.error_message = null
      // let check = await this.$validator.validateAll()
      // if (!check) { return }
      this.e1 = 2
      let data = Object.assign({}, this.new_shopDefaultData)
      data.localization_id = -1
      // data.localization_text = 'Apply to all POS'
      this.new_shop = data
    },
    stepper_go_to_step_3 () {
      // configure shop level information
      this.error_message = null
      this.e1 = 3
      this.new_shop.airport_name = this.getSelectedAirport.label
      this.new_pos = [Object.assign({}, this.new_shopDefaultData)]
      this.current_pos = 0
    },
    stepper_go_to_step_4 () {
      // go to resume
      this.error_message = null
      this.e1 = 4
      this.new_pos.map(pos => { pos.airport_name = this.getSelectedAirport.label })
    },
    stepper_go_to_step_4_new_pos () {
      // configure new POS level information
      this.error_message = null
      this.e1 = 3
      this.new_pos.push(Object.assign({}, this.new_shopDefaultData))
      this.current_pos = this.new_pos.length - 1
    },
    stepper_go_to_step_5 () {
      this.error_message = null
      this.submit_new_shop()
    },
    showPosForm (item) {
      this.error_message = null
      this.e1 = 3
      this.current_pos = this.new_pos.indexOf(item)
    },
    createChangeRequest () {
      var normalTypeFields = ['name', 'localization_text', 'note', 'url', 'description', 'iata_code']
      var m2oTypeFields = ['who', 'what', 'how']

      var operations = []
      // ajouter operation pour l'airport: this.getSelectedAirport.iata_code
      this.new_shop.iata_code = this.getSelectedAirport.iata

      // put shop first on the new_pos list
      this.new_pos.unshift(this.new_shop)
      for (const localization of this.new_pos) {
        let localizationId = this.new_pos.indexOf(localization)
        // process normal field type
        for (const fieldName of normalTypeFields) {
          if (localization[fieldName] !== undefined && localization[fieldName] !== '') {
            operations.push({
              'localization_id': localizationId,
              'field_name': fieldName,
              'field_type': 'string', // string, int, double
              'value_new': localization[fieldName],
              'operation_type': 'add',
              'comment': localization[fieldName + '_comment']
            })
          }
        }
        // process m2o fields type
        for (const fieldName of m2oTypeFields) {
          var valueNewM2o = []
          if (localization[fieldName].length > 0) {
            for (const tag of localization[fieldName]) {
              valueNewM2o.push(['add', tag])
            }
          }
          if (valueNewM2o.length > 0) {
            operations.push({
              'localization_id': localizationId,
              'field_name': fieldName,
              'field_type': 'm2o', // string, int, double, m2o
              'value_new': valueNewM2o, // 2: add
              'operation_type': 'add',
              'comment': localization[fieldName + '_comment']
            })
          }
        }
      }
      var changeRequestObject = {
        'type': 'create',
        'operations': operations
      }
      this.$apollo.mutate({
        mutation: CREATE_CHANGE_REQUEST,
        variables: {
          change_request: changeRequestObject
        }
      }).then((data) => { this.e1 = 5 })
        .catch((error) => {
          if (error.networkError.statusCode === 401) {
            this.$auth0.login()
          } else {
            this.addError(error)
          }
        })
    },
    async submit_new_shop () {
      // let check = await this.$validator.validateAll()
      // if (!check) { return }
      // let diff = this.difference(this.viewedChangeRequest, this.viewedChangeRequestOrig)
      // // Check the user edit at least one other field than proof_comment.
      // if (Object.keys(diff).length == 1) {
      //   alert("You must edit at least one field.")
      //   return
      // }
      this.createChangeRequest()
    },
    onPopupClose (event) {
      if (event === undefined) {
        this.closePopup()
      }
    },
    async closePopup () {
      this.setViewedAddShopDialog(false)
      // this.localization_id = -1;
      // this.localization = false;
      this.e1 = 1
      this.new_shop = []
      this.new_pos = []
      this.iata_selected = false
    },
    hasData (item) {
      if (item.url) { return true }
      if (item.who && item.who.length > 0) { return true }
      if (item.what && item.what.length > 0) { return true }
      if (item.how && item.how.length > 0) { return true }
      if (item.description) { return true }
      if (item.note) { return true }
      return false
    },
    hasCommonInformation (item) {
      if (item.url) { return true }
      if (item.who && item.who.length > 0) { return true }
      if (item.what && item.what.length > 0) { return true }
      if (item.how && item.how.length > 0) { return true }
      if (item.description) { return true }
      return false
    }
  },
  apollo: {
    allAirports: {
      query: ALL_AIRPORTS
    }
  }
}
</script>
<style>
.addShopDialog .v-input {
    padding: 5px;
}
.addShopDialog .v-input--selection-controls {
    padding: 0px;
    margin: 0px;
}
.addShopDialog .v-input--selection-controls .v-input__slot {
  margin-bottom: 0px;
}
.addShopDialog {
  width:1500px !important;
}
</style>
